export default __webpack_public_path__ + "static/media/katastima-marousi.5cfdcb57.jpeg";